export const getThemePath = (path: string) => {
  const prefix = import.meta.env.PROD ? "/wp-content/themes/szekla" : "";

  return `${prefix}${path}`;
};
